// vim: set ts=2 sw=2 et tw=72 ft=javascript:
/**
 * Copyright (C) 2016 Minted Inc.
 * All Rights Reserved
 * CTAG:COMMUNITY:CHALLENGES
 */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/moment.min.js': 'moment',
  'minted:vendor/underscore-1.8.2.min': '_',
})(this, function (m_module, Backbone, $, moment, _) {
  'use strict';

  var M = m_module.M;
  M.Community = M.Community || {};
  M.Community.View = M.Community.View || {};
  M.Community.View.Challenge = M.Community.View.Challenge || {};

  M.Community.View.Challenge.FeedbackComponent = Backbone.View.extend({
    template: M.Template.Community.Challenge.FeedbackComponent,

    initialize: function() {
      this.$el = $(this.el);
      this.container = this._constructContainer();
      // Init parent container
      this.container.render();
      this.$containerEl = this.container.$el;
      this._attachClickHandlers();
    },

    render: function() {
      this.options.model = this.model;
      var templateHTML = this.template(this.options);
      this.$el.html(templateHTML);
      return this.$el;
    },

    _attachClickHandlers: function() {
      var that = this;
      var $buttonContainer = this.$containerEl.find('.actionButtonContainer');
      $buttonContainer.find('a').removeAttr('href');
      $buttonContainer.find('button').click(function(e) {
        that._handleClick();
      });
    },

    _handleClick: function() {
      var that = this;
      if (!M.currentUser.uid) {
        M.Url.RedirectToLogin();
      } else {
        that.renderFeedbackGallery();
      }
    },

    _constructContainer: function() {
      this.options.component = this;
      return new M.Community.View.Challenge.SquarePanel(this.options);
    },

    _constructFeedbackGallery: function() {
      var designerInfo = {
        designerProfilePageUrl: this.options.designerProfilePageUrl,
        designerAvatarUrl: this.options.designerAvatarUrl,
        designerName: this.options.designerName,
        designerLocation: this.options.designerLocation
      };

      var feedbackGalleryWidgetInfo = {
        buttonLabel: 'Go to Next',
        challengeName: this.options.challengeName,
        designId: this.options.designId,
        designName: this.options.designName,
        designThumbnail: this.options.designThumbnail,
        designRatingPageUrl: this.options.designRatingPageUrl,
        designerInfo: designerInfo,
        feedbackRequestMsg: this.options.feedbackRequestMsg
      };

      var modelForCurrentDesign =
          new M.Community.Model.FeedbackGallery(feedbackGalleryWidgetInfo);
      var collectionModels = [ modelForCurrentDesign ];
      var collectionOptions = {
        feedbackGalleryUrlPath: this.options.feedbackGalleryUrlPath
      };
      var collection = new M.Community.Collection.FeedbackWidgetList (
          collectionModels,
          collectionOptions
      );

      var feedbackWidget = new M.Community.View.FeedbackGallery({
        collection: collection,
        commentsUrlPath: this.options.commentsUrlPath,
        challengeId: this.options.challengeId,
        challengeName: this.options.challengeName,
        designId: this.options.designId,
        designName: this.options.designName,
        recentCommentsLimit: this.options.recentCommentsLimit
      });

      return feedbackWidget;
    },

    _constructDialogForFeedbackGallery: function($parentEl) {
      $parentEl.dialog({
        dialogClass: "no-title-with-close flat-white-ui",
        draggable: false,
        width: 1200,
        modal: true,
        autoOpen: false,
        resizable: false,
        position: ['center', 100]
      });
    },

    renderFeedbackGallery: function() {
      if (!this.$feedbackGalleryWidget){
        this.$feedbackGalleryWidget = this._constructFeedbackGallery();
        this.$feedbackGalleryWidget.fetchDataAndRender();
        this._constructDialogForFeedbackGallery(this.$feedbackGalleryWidget.$el);
      }
      this.$feedbackGalleryWidget.$el.dialog('open');
    },
  });

  return {  };
});
